import React from 'react';
import Typography from '@mui/material/Typography';
import i18n from '../../i18n';

type SubFunctionAuxiliaryHintProps = {
    /** 顶栏「辅助模式」开启时为 true */
    enabled: boolean;
    /** i18n 文案 key（与 Figma 导出一致） */
    i18nKey: string;
    /** 可选根 className（页面 BEM，如 `__aux-hint`）；默认字色为 Typography **`color="text.secondary"`** */
    className?: string;
};

/**
 * 云 RBP 子功能壳内通用：辅助模式开启时在设置项下方展示设计稿次要说明（Typography body2）。
 */
export function SubFunctionAuxiliaryHint(props: SubFunctionAuxiliaryHintProps): React.ReactElement | null {
    const { enabled, i18nKey, className } = props;
    if (!enabled) {
        return null;
    }
    return (
        <Typography variant="body2" component="div" color="text.secondary" className={className}>
            {i18n.t(i18nKey)}
        </Typography>
    );
}
